import React from "react";
import { InView } from 'react-intersection-observer';

const KeyFeatures = () => {
  const features = [
    {
      emoji: "🎊",
      title: "Ready-Made Festival Posters",
      description: "Access professionally designed posters for every Indian festival, national day, jayanti, punyatithi, awareness day, business promotion, and special occasion.",
      gradient: "from-purple-500 to-pink-500"
    },
    {
      emoji: "✨",
      title: "AI Background Remover",
      description: "Remove image backgrounds with a single tap and create professional-looking posters instantly.",
      gradient: "from-blue-500 to-cyan-500"
    },
    {
      emoji: "📝",
      title: "AI Text Remover",
      description: "Erase unwanted text from any image seamlessly while maintaining a clean, natural look.",
      gradient: "from-emerald-500 to-teal-500"
    },
    {
      emoji: "🎂",
      title: "Birthdays & Anniversaries",
      description: "Save your contacts and receive timely reminders. Instantly create personalized greeting posters for every special moment.",
      gradient: "from-orange-500 to-red-500"
    },
    {
      emoji: "🎨",
      title: "AI Logo Maker",
      description: "Design modern, professional logos for your business, brand, shop, startup, or personal identity in just a few clicks.",
      gradient: "from-indigo-500 to-purple-500"
    },
    {
      emoji: "📅",
      title: "Online Panchang",
      description: "Stay updated with daily Panchang information including Tithi, Nakshatra, Choghadiya, Rahu Kaal, and other Hindu calendar details.",
      gradient: "from-yellow-500 to-orange-500"
    },
    {
      emoji: "🌟",
      title: "Business Spotlight",
      description: "Promote your business to a wider audience through our Business Spotlight section and increase your brand visibility.",
      gradient: "from-rose-500 to-pink-500"
    },
    {
      emoji: "💰",
      title: "Refer & Earn",
      description: "Invite your friends to Edit Ezy. Earn ₹200 for every successful yearly subscription purchased using your referral.",
      gradient: "from-green-500 to-emerald-500"
    },
    {
      emoji: "🚀",
      title: "Premium Subscription",
      description: "Enjoy unlimited access to premium templates and powerful AI tools for only ₹499 per year.",
      gradient: "from-violet-500 to-purple-500"
    }
  ];

  return (
    <div className="bg-gray-950 min-h-screen py-20">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-4xl sm:text-5xl font-bold mb-6">
          <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent">
            Key Features
          </span>
        </h2>
        <p className="text-lg text-gray-400 mb-16 max-w-3xl mx-auto">
          Discover the powerful tools that make Edit Ezy the perfect choice for your festival and business poster needs
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <InView key={index} triggerOnce={true} threshold={0.3}>
              {({ inView, ref }) => (
                <div
                  ref={ref}
                  className={`bg-gray-900 rounded-2xl p-8 border border-gray-800 hover:border-gray-700 transition-all duration-500 transform hover:-translate-y-2 hover:shadow-2xl hover:shadow-purple-500/10 group ${
                    inView ? 'animate__animated animate__fadeInUp' : 'opacity-0'
                  }`}
                  style={{ animationDelay: `${index * 100}ms` }}
                >
                  <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${feature.gradient} flex items-center justify-center text-3xl mx-auto mb-6 group-hover:scale-110 transition-transform duration-300`}>
                    {feature.emoji}
                  </div>
                  <h3 className="text-xl font-bold text-white mb-4">{feature.title}</h3>
                  <p className="text-gray-400 leading-relaxed">{feature.description}</p>
                </div>
              )}
            </InView>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KeyFeatures;